import { fetchGetStateByStateKey } from '@iwoca/lapi-client/edge';
import { TGetStateResponseData } from 'lendingApi/lapiOverrides.types';
import { useNavigate } from 'react-router-dom';
import { IwQueryClient } from 'store/IwQueryClient';
import { TSignupSteps } from 'types';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { useApplicationTable } from './ApplicationTable.context';

export function useContinueRedirect() {
  const navigate = useNavigate();
  const { redirectionId, setRedirectionId } = useApplicationTable();

  const getRedirectUrl = (applicationId: string, step?: TSignupSteps) => {
    if (!step) {
      return PATH_NAMES.newApplicationStep1({ applicationId });
    }

    return PATH_NAMES.newApplication({ step, applicationId });
  };

  const handleRedirect = async (stateKey: string, applicationId: string) => {
    try {
      IwQueryClient.getOrCreate().invalidateQueries({
        queryKey: ['offers', applicationId],
      });
      setRedirectionId(stateKey);
      const response = await fetchGetStateByStateKey({
        stateKey,
      });
      const state = response.data as TGetStateResponseData;
      navigate(getRedirectUrl(applicationId, state.ui?.tip_latest_signup_step));
    } catch {
      // If error, redirect to signup step 1
      navigate(getRedirectUrl(applicationId));
    } finally {
      setRedirectionId();
    }
  };

  return { handleRedirect, getRedirectUrl, redirectionId };
}
